import styled from '@emotion/styled'

export const ButtonContainer = styled.div`
  padding: 20px;
  text-align: center;
`
